import { useState } from 'react';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import packageJson from '../../../package.json';
import { useBranding } from 'contexts/BrandingContext';
import { useAuth } from 'contexts/AuthContext';
import ChangelogModal from 'components/ChangelogModal';

export default function Footer() {
  const { branding } = useBranding();
  const { user } = useAuth();
  const [changelogOpen, setChangelogOpen] = useState(false);

  const isAdmin = user?.role === 'admin';

  const handleVersionClick = () => {
    if (isAdmin) {
      setChangelogOpen(true);
    }
  };

  return (
    <>
      <Stack direction="row" sx={{ alignItems: 'center', justifyContent: 'space-between', p: '24px 16px 0px', mt: 'auto' }}>
        <Typography variant="caption">
          &copy; All rights reserved{' '}
          <Link href={branding?.company?.website} target="_blank" underline="hover">
            {branding?.company?.name}
          </Link>{' '}
          {isAdmin ? (
            <Link component="span" onClick={handleVersionClick} sx={{ cursor: 'pointer' }} underline="hover">
              v{packageJson.version}
            </Link>
          ) : (
            <span>v{packageJson.version}</span>
          )}
        </Typography>
        <Stack direction="row" sx={{ gap: 1.5, alignItems: 'center', justifyContent: 'space-between' }}>
          <Link
            href={branding?.legal?.about_us_url}
            target="_blank"
            variant="caption"
            sx={{
              color: 'text.primary'
            }}
          >
            About us
          </Link>
          <Link
            href={branding?.legal?.privacy_policy_url}
            target="_blank"
            variant="caption"
            sx={{
              color: 'text.primary'
            }}
          >
            Privacy
          </Link>
          <Link
            href={branding?.legal?.terms_of_service_url}
            target="_blank"
            variant="caption"
            sx={{
              color: 'text.primary'
            }}
          >
            Terms of Use
          </Link>
        </Stack>
      </Stack>

      {isAdmin && <ChangelogModal open={changelogOpen} onClose={() => setChangelogOpen(false)} version={packageJson.version} />}
    </>
  );
}
